module.exports = __webpack_public_path__ + "static/media/icon_calendar.235cb6a5.svg";